var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-popover",
    {
      attrs: {
        placement: _vm.placement,
        trigger: "click",
        overlayClassName: _vm.popoverClass + " modern-select-popover",
      },
      model: {
        value: _vm.popoverVisible,
        callback: function ($$v) {
          _vm.popoverVisible = $$v
        },
        expression: "popoverVisible",
      },
    },
    [
      _c("template", { slot: "content" }, [
        _c("div", { staticClass: "modern-select-dropdown" }, [
          _vm.showHeader
            ? _c("div", { staticClass: "select-header" }, [
                _c("span", { staticClass: "select-title" }, [
                  _vm._v(_vm._s(_vm.headerTitle)),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.enableSearch
            ? _c("div", { staticClass: "select-search" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchQuery,
                      expression: "searchQuery",
                    },
                  ],
                  staticClass: "search-input",
                  attrs: { type: "text", placeholder: _vm.searchPlaceholder },
                  domProps: { value: _vm.searchQuery },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.searchQuery = $event.target.value
                    },
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "select-options" },
            [
              _vm._l(_vm.processedOptions.ungrouped, function (opt) {
                var _obj
                return _c(
                  "a-tooltip",
                  {
                    key: opt.value,
                    attrs: {
                      placement: "right",
                      title: opt.fullLabel || opt.label,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "select-option",
                        class: {
                          active:
                            !_vm.hideSelection &&
                            (_vm.multiple
                              ? Array.isArray(_vm.internalValue) &&
                                _vm.internalValue.includes(opt.value)
                              : _vm.internalValue === opt.value &&
                                _vm.internalValue !== "" &&
                                _vm.internalValue !== null &&
                                _vm.internalValue !== undefined),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onSelect(opt.value)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "option-content" },
                          [
                            opt.iconType === "component"
                              ? _c(opt.icon, {
                                  tag: "component",
                                  class:
                                    ((_obj = { "option-icon-component": true }),
                                    (_obj[opt.icon] = true),
                                    _obj),
                                })
                              : opt.icon
                              ? _c(
                                  "i",
                                  { staticClass: "material-icons option-icon" },
                                  [_vm._v(_vm._s(opt.icon))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", { staticClass: "option-label" }, [
                              _vm._v(_vm._s(opt.label)),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.hideSelection &&
                        (_vm.multiple
                          ? Array.isArray(_vm.internalValue) &&
                            _vm.internalValue.includes(opt.value)
                          : _vm.internalValue === opt.value &&
                            _vm.internalValue !== "" &&
                            _vm.internalValue !== null &&
                            _vm.internalValue !== undefined)
                          ? _c(
                              "i",
                              { staticClass: "material-icons check-icon" },
                              [_vm._v(_vm._s(_vm.checkIcon))]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                )
              }),
              _vm._v(" "),
              _vm._l(_vm.processedOptions.groups, function (group) {
                return [
                  _c(
                    "div",
                    {
                      key: "header-" + group.name,
                      staticClass: "group-header",
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(group.name) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(group.items, function (opt) {
                    var _obj
                    return _c(
                      "a-tooltip",
                      {
                        key: opt.value,
                        attrs: {
                          placement: "right",
                          title: opt.fullLabel || opt.label,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "select-option",
                            class: {
                              active:
                                !_vm.hideSelection &&
                                (_vm.multiple
                                  ? Array.isArray(_vm.internalValue) &&
                                    _vm.internalValue.includes(opt.value)
                                  : _vm.internalValue === opt.value &&
                                    _vm.internalValue !== "" &&
                                    _vm.internalValue !== null &&
                                    _vm.internalValue !== undefined),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onSelect(opt.value)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "option-content" },
                              [
                                opt.iconType === "component"
                                  ? _c(opt.icon, {
                                      tag: "component",
                                      class:
                                        ((_obj = {
                                          "option-icon-component": true,
                                        }),
                                        (_obj[opt.icon] = true),
                                        _obj),
                                    })
                                  : opt.icon
                                  ? _c(
                                      "i",
                                      {
                                        staticClass:
                                          "material-icons option-icon",
                                      },
                                      [_vm._v(_vm._s(opt.icon))]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", { staticClass: "option-label" }, [
                                  _vm._v(_vm._s(opt.label)),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !_vm.hideSelection &&
                            (_vm.multiple
                              ? Array.isArray(_vm.internalValue) &&
                                _vm.internalValue.includes(opt.value)
                              : _vm.internalValue === opt.value &&
                                _vm.internalValue !== "" &&
                                _vm.internalValue !== null &&
                                _vm.internalValue !== undefined)
                              ? _c(
                                  "i",
                                  { staticClass: "material-icons check-icon" },
                                  [_vm._v(_vm._s(_vm.checkIcon))]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    )
                  }),
                ]
              }),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modern-select-trigger", class: _vm.triggerClass },
        [
          _vm._t("trigger", function () {
            return [
              _c(
                "div",
                { staticClass: "select-button", class: _vm.buttonClass },
                [
                  _vm.showIcon && _vm.currentIcon && !_vm.hideSelection
                    ? _c("i", { staticClass: "material-icons button-icon" }, [
                        _vm._v(_vm._s(_vm.currentIcon)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.hideSelection
                    ? _c("span", { staticClass: "button-text-v2" }, [
                        _vm._v(_vm._s(_vm.currentLabel)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.removable
                    ? _c(
                        "i",
                        {
                          staticClass: "material-icons chip-remove-inline",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.onRemoveClick.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("close")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.clearable && !_vm.removable
                    ? _c(
                        "i",
                        {
                          staticClass: "material-icons chip-clear-inline",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.onClearClick.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("delete_forever")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showDropdownArrow
                    ? _c(
                        "i",
                        { staticClass: "material-icons dropdown-arrow" },
                        [_vm._v("keyboard_arrow_down")]
                      )
                    : _vm._e(),
                ]
              ),
            ]
          }),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }